// How far the frame is allowed to extend beyond the card box on every side.
// Kept equal across all frames so the card can reserve a fixed bleed margin.
export const BLEED = 12;

// A rotated square (rhombus) centred at (cx,cy) with half-diagonal s.
function diamondPath(cx, cy, s) {
  return `M ${cx} ${cy - s} L ${cx + s} ${cy} L ${cx} ${cy + s} L ${cx - s} ${cy} Z`;
}

// Vivid neon-green outline (night street-meet convoy). Glow is faked with three
// stacked strokes of decreasing width / increasing opacity (react-native-svg has
// no reliable blur filter on iOS), plus rotated-square diamond accents at the
// four corners and the top/bottom mid-edges. Decoration stays on the border and
// in the bleed margin so the card's content area is never covered.
export default function StreetNeonFrame({ w, h, radius = 12, accent = '#2bff88' }) {
  const W = w + BLEED * 2;
  const H = h + BLEED * 2;
  const x = BLEED;
  const y = BLEED;
  const r = radius + 2;
  const corners = [[x, y], [x + w, y], [x, y + h], [x + w, y + h]];
  const midEdges = [[x + w / 2, y], [x + w / 2, y + h]];
  return (
    <div style={{ position: 'absolute', top: -BLEED, left: -BLEED, width: W, height: H, pointerEvents: 'none' }}>
      <svg width={W} height={H} xmlns="http://www.w3.org/2000/svg">
        {/* three stacked strokes -> faux neon glow */}
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="#39ff14" strokeWidth={7} opacity={0.14} />
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="#2bff88" strokeWidth={3.5} opacity={0.5} />
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="#b7ffd4" strokeWidth={1.5} opacity={0.95} />

        {/* corner diamonds: dim halo + bright core + white centre */}
        {corners.map(([cx, cy], i) => (
          <path key={`ch-${i}`} d={diamondPath(cx, cy, 8)} fill="#39ff14" opacity={0.18} />
        ))}
        {corners.map(([cx, cy], i) => (
          <path key={`cc-${i}`} d={diamondPath(cx, cy, 5)} fill="#2bff88" opacity={0.95} />
        ))}
        {corners.map(([cx, cy], i) => (
          <path key={`ci-${i}`} d={diamondPath(cx, cy, 2.2)} fill="#eaffef" opacity={0.95} />
        ))}

        {/* mid-edge diamonds (top + bottom centre) */}
        {midEdges.map(([cx, cy], i) => (
          <path key={`mh-${i}`} d={diamondPath(cx, cy, 6)} fill="#39ff14" opacity={0.2} />
        ))}
        {midEdges.map(([cx, cy], i) => (
          <path key={`mc-${i}`} d={diamondPath(cx, cy, 3.6)} fill="#7dffb0" opacity={0.92} />
        ))}
      </svg>
    </div>
  );
}
